/**
 * @generated SignedSource<<3977f50e221329a05ca9e819f2f6992d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type MarketingEmailStatus = "DRAFT" | "PARTIALLY_SENT" | "SENDING" | "SENT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type MarketingEmailDetailsView_marketingEmail$data = {
  readonly archivedAt: any | null | undefined;
  readonly createdAt: any;
  readonly emailTemplate: {
    readonly emailLayout: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly emailTemplateIdentifier: string;
    readonly id: string;
    readonly name: string;
    readonly primaryLanguage: string;
    readonly variants: ReadonlyArray<{
      readonly language: string;
      readonly preheader: string | null | undefined;
      readonly subject: string | null | undefined;
    }>;
  } | null | undefined;
  readonly id: string;
  readonly mailingList: {
    readonly id: string;
    readonly mailingListIdentifier: string;
    readonly name: string;
    readonly subscribedCount: number;
  } | null | undefined;
  readonly marketingEmailIdentifier: string;
  readonly name: string;
  readonly replyToEmail: string | null | undefined;
  readonly senderEmail: string;
  readonly senderName: string;
  readonly sentAt: any | null | undefined;
  readonly status: MarketingEmailStatus;
  readonly " $fragmentType": "MarketingEmailDetailsView_marketingEmail";
};
export type MarketingEmailDetailsView_marketingEmail$key = {
  readonly " $data"?: MarketingEmailDetailsView_marketingEmail$data;
  readonly " $fragmentSpreads": FragmentRefs<"MarketingEmailDetailsView_marketingEmail">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MarketingEmailDetailsView_marketingEmail",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "marketingEmailIdentifier",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "senderName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "senderEmail",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "replyToEmail",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sentAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "archivedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MailingList",
      "kind": "LinkedField",
      "name": "mailingList",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mailingListIdentifier",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subscribedCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EmailTemplate",
      "kind": "LinkedField",
      "name": "emailTemplate",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailTemplateIdentifier",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "primaryLanguage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EmailTemplateVariant",
          "kind": "LinkedField",
          "name": "variants",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "language",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subject",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "preheader",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EmailLayout",
          "kind": "LinkedField",
          "name": "emailLayout",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MarketingEmail",
  "abstractKey": null
};
})();

(node as any).hash = "4db7de8c06bb61aa150fe7548a31e9b7";

export default node;
